module.exports = __webpack_public_path__ + "static/media/crane_logo_small.5fecc8fb.png";